// Actualités IA par région (/news/ai/:region). Extrait de app/page.tsx.
import { useEffect, useState } from 'react'
import type { AiNews } from '@/types/landing'

const API = process.env.NEXT_PUBLIC_API_URL ?? ''

export function useNews(region: string) {
  const [news, setNews] = useState<AiNews | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true); setNews(null)
    fetch(`${API}/news/ai/${region}`)
      .then(r => r.json()).then(setNews).catch(() => null)
      .finally(() => setLoading(false))
  }, [region])

  return { news, loading }
}
